type Environment = {
    apiUrl: string;
    userStorage: string;
    storage: string;
    isDev: boolean;
    url: string;
};

const isDev = process.env.NODE_ENV === 'development';

const environment: Environment = {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3333',
    userStorage: process.env.REACT_APP_USER_STORAGE || 'user-logged',
    storage: process.env.REACT_APP_STORAGE || 'app-storage-',
    isDev,
    url: process.env.REACT_APP_APP_URL || 'http://localhost:3000'
};

export default environment;
